import { type ReactNode } from 'react';

import { Button, Typography } from 'antd';
import type { Dayjs } from 'dayjs';

export const renderMiniHeader = ({
  value,
  onChange,
}: {
  value: Dayjs;
  onChange: (d: Dayjs) => void;
}): ReactNode => {
  const prev = () => onChange(value.clone().subtract(1, 'month'));
  const next = () => onChange(value.clone().add(1, 'month'));
  return (
    <div className="mini-calendar-header">
      <Button className="mini-calendar-nav-btn nav-left" size="small" onClick={prev} />
      <Typography.Text className="mini-calendar-title">{value.format('MMMM YYYY')}</Typography.Text>
      <Button className="mini-calendar-nav-btn nav-right" size="small" onClick={next} />
    </div>
  );
};
